<template>
  <div>
    <SummaryPanel :project="project"/>

    <DescriptionPanel :project="project"/>

    <div class="row">
      <div class="col-xs-12">
        <AdList :project="project"/>

        <ReminderList :project="project"/>

        <OpportunityList :project="project"/>
      </div>

      <div class="col-xs-12">
        <PartnerList :project="project"/>

        <LeadList :project="project"/>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryPanel from "../../../../components/Relations/Projects/Panels/Dashboard/Summary.vue";
import AdList from "../../../../components/Relations/Projects/Panels/Dashboard/AdList.vue";
import OpportunityList from "../../../../components/Relations/Projects/Panels/Dashboard/OpportunityList.vue";
import LeadList from "../../../../components/Relations/Projects/Panels/Dashboard/LeadList.vue";
import ReminderList from "../../../../components/Relations/Projects/Panels/Dashboard/ReminderList.vue";
import DescriptionPanel from "../../../../components/Relations/Projects/Panels/Dashboard/DescriptionPanel.vue";
import PartnerList from "../../../../components/Relations/Projects/Panels/Dashboard/PartnerList.vue";

export default {
  components: {PartnerList, DescriptionPanel, ReminderList, LeadList, AdList, SummaryPanel, OpportunityList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
